export const CARD_STATUS_TYPES = {
    TANK_IN_HANGAR: 'TANK_IN_HANGAR',
    REWARD_RECEIVED: 'REWARD_RECEIVED',
    OTHER_REWARD_SELECTED: 'OTHER_REWARD_SELECTED',
    REWARDING_NOT_STARTED: 'REWARDING_NOT_STARTED',
    REWARDING_STARTED: 'REWARDING_STARTED',
    AUCTION_AVAILABLE: 'AUCTION_AVAILABLE',
    AUCTION_BET_APPLIED: 'AUCTION_BET_APPLIED',
}



// WEBPACK FOOTER //
// ./containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsTankCard/constants.js